export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const SET_LOADER = 'SET_LOADER'
export const LOGIN_FAIL = 'LOGIN_FAIL'
